import type { PeriodPreset } from '@/helpers';

export const PRESET_LABEL_KEYS: Record<PeriodPreset, string> = {
  day: 'Day',
  month: 'Month',
  year: 'Year',
  custom: 'Custom period',
};

export const YEAR_SPAN = 10;
